/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    color: '#394056',
    fontName: 'SofiaPro',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 1.4285714285714286
  }
}
export default theme
